import React from 'react';
import {MDBContainer, MDBRow, MDBCol, MDBCard} from 'mdb-react-ui-kit';

/**
 *  InfoToDoListView
 * @param {*} props props
 * @return {JSX}
 */
function InfoToDoListView(props) {
  return (
    <MDBContainer className="modal" fluid >
      <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content" style={{marginTop: '100px'}}>
        <MDBCol col="12">
          <MDBCard
            className="bg-dark text-white my-5 mx-auto align-items-center"
            style={{borderRadius: '1rem', maxWidth: '800px'}}>
            <span className="employe-close" onClick={props.closeModal} style={{marginRight: '20px', marginTop: '10px'}}>
            &times;
            </span>
            <h2 className="fw-bold mb-2 text-uppercase" style={{marginTop: '30px'}}>
            Informations
            </h2>
            <h4 className="fw-bold mb-2 text-uppercase" style={{marginTop: '30px'}}>
            Date ajouté: {props.todolist.date_ajoute}
            </h4>

          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
}

export default InfoToDoListView;
